import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import GtmLeadsPage from '@/pages/gtm-workspace/leads'
import { requireGtmWorkspace } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  project: z.string().uuid().optional(),
  // Accepted for old links; Leads is a single outreach queue now.
  filter: z.string().optional(),
  lead: z.string().uuid().optional(),
})

export const Route = createFileRoute('/$lang/workspace/$workspaceId/gtm/leads')(
  {
    validateSearch: (search) => searchSchema.parse(search),
    beforeLoad: ({ context, params }) => requireGtmWorkspace(context, params),
    component: GtmLeadsPage,
    staticData: { layout: 'main' },
  },
)
